"use client"

// ============================================
// DOCUMENTS SECTION COMPONENT
// ============================================
import {
  FaFileDownload,
  FaFileInvoice,
  FaIdCard,
  FaFileContract,
  FaBuilding,
  FaFileSignature,
  FaMoneyCheckAlt,
  FaFileAlt,
  FaCheckCircle,
  FaTimesCircle,
  FaEye,
  FaBell,
} from "react-icons/fa"
import { formatDocumentName } from "./shared"

const DocumentsSection = ({ selectedUser, userDocuments, sendMissingDocNotification }) => {
  const getDocumentIcon = (docType) => {
    const icons = {
      gstCopy: FaFileInvoice,
      panCard: FaIdCard,
      workOrder: FaFileContract,
      purchaseOrder: FaBuilding,
      partnershipDeed: FaFileSignature,
      cancelCheque: FaMoneyCheckAlt,
    }
    const Icon = icons[docType] || FaFileAlt
    return <Icon />
  }

  const hasDocuments = Object.keys(userDocuments || {}).length > 0

  return (
    <div className="documents-tab">
      <div className="section-header">
        <FaFileDownload className="section-icon" />
        <h2>User Uploaded Documents</h2>
      </div>
      <p className="section-subtitle">Documents uploaded by {selectedUser.username || selectedUser.email}</p>

      {!hasDocuments ? (
        <div className="empty-state">
          <FaFileAlt className="empty-icon" />
          <p>No documents found</p>
        </div>
      ) : (
        Object.entries(userDocuments || {}).map(([codeId, docs]) => {
          const missingDocs = Object.keys(docs).filter((docType) => !docs[docType])

          return (
            <div key={codeId} className="code-documents">
              <div className="code-doc-header">
                <h3 className="code-heading">
                  Code ID: <span className="code-id-badge">{codeId}</span>
                </h3>
                {missingDocs.length > 0 && (
                  <button
                    onClick={() =>
                      sendMissingDocNotification(selectedUser, missingDocs.map(formatDocumentName), codeId)
                    }
                    className="notify-btn"
                    title="Notify User for missing documents"
                  >
                    <FaBell /> Notify
                  </button>
                )}
              </div>

              <div className="documents-grid">
                {Object.keys(docs || {}).map((docType) => (
                  <div key={docType} className="document-card">
                    <div className="document-icon">{getDocumentIcon(docType)}</div>
                    <div className="document-info">
                      <h4>{formatDocumentName(docType)}</h4>
                      <div className="document-status">
                        {docs[docType] ? (
                          <span className="status-uploaded">
                            <FaCheckCircle /> Uploaded
                          </span>
                        ) : (
                          <span className="status-missing">
                            <FaTimesCircle /> Not Uploaded
                          </span>
                        )}
                      </div>
                    </div>
                    {docs[docType] && (
                      <div className="document-actions">
                        <button
                          onClick={() => window.open(docs[docType], "_blank")}
                          className="view-doc-btn"
                          title="View Document"
                        >
                          <FaEye /> View
                        </button>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          )
        })
      )}
    </div>
  )
}

export default DocumentsSection
